import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center text-black text-lg" }
const _hoisted_2 = { class: "flex justify-between" }

import {  File } from "@/../../EshJSLib/models/patient";
import { ref } from "vue";
import { Modal } from "flowbite-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'modal_anteprima',
  setup(__props, { expose: __expose }) {

let row = ref({} as File);

const alertConfirmMessage = ref<null | string>(null);
const modalType = ref<"confirm" | "alert">("confirm");
const showConfirm = ref(false);
const dataRegistrato = ref(); 
const dataCaricato = ref();

let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;

function openModal(message: string, alertModal: boolean, rowData: File) {
    row.value = rowData

    alertConfirmMessage.value = message + ": " + rowData.file_nome;
    alertModal ? (modalType.value = "alert") : (modalType.value = "confirm");
    showConfirm.value = true;
    dataRegistrato.value = rowData.data_reg;
    dataCaricato.value = rowData.date_display;
    return new Promise((resolve) => {
        resolvePromise = resolve;
    });    
}

function handleUserInput(value: boolean) {
    if (!resolvePromise) return;
    resolvePromise(value);
    showConfirm.value = false;
}

__expose({ openModal });

return (_ctx: any,_cache: any) => {
  return (showConfirm.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        size: "2xl",
        onClose: _cache[2] || (_cache[2] = ($event: any) => (handleUserInput(false)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(alertConfirmMessage.value)), 1)
        ]),
        body: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("Registrato il: ")) + " " + _toDisplayString(dataRegistrato.value), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("Caricato il:")) + " " + _toDisplayString(dataCaricato.value), 1)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleUserInput(false))),
              type: "button",
              class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            }, _toDisplayString(_ctx.$t("Annulla")), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleUserInput(true))),
              type: "button",
              class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            }, _toDisplayString(_ctx.$t(" Anteprima Kardia")), 1)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})